import { ErrorCodes } from '../constants';
import { PaymentRequestError } from '../types';

export default function createPaymentRequestError(
  code: ErrorCodes | string,
  message: string,
): PaymentRequestError {
  return {
    error: {
      code,
      message,
    },
  };
}
